import { createContext, useContext } from "react";
const CheckboxGroupContext = createContext(null);
function useCheckboxGroupProvider() {
  return useContext(CheckboxGroupContext);
}
export {
  CheckboxGroupContext,
  useCheckboxGroupProvider
};
